import React from 'react';
import { Link } from 'react-router-dom';
import { homeAnchor } from '../pages/HomePage';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <Link to="/" className="footer__logo">
            <img src="/assets/logo.jpg" alt="BikesDrop logo" />
            <span>
              Bikes<span className="footer__logo-accent">Drop</span>
            </span>
          </Link>
          <p>Your Ride, Your Delivery, Your Way.</p>
          <p className="footer__mute">
            Ghana&rsquo;s all-in-one platform for delivery, cargo and campus errands, connecting
            customers, riders and merchants.
          </p>
          <p className="footer__mute">Powered by BikesDrop Business and Logistics LTD.</p>
        </div>

        <div className="footer__col">
          <h4>Platform</h4>
          <Link to={homeAnchor('services')}>Services</Link>
          <Link to={homeAnchor('customer')}>Customer App</Link>
          <Link to={homeAnchor('business')}>BikesDrop Business</Link>
        </div>

        <div className="footer__col">
          <h4>Company</h4>
          <Link to={homeAnchor('why')}>What&rsquo;s New</Link>
          <Link to={homeAnchor('vision')}>Vision &amp; Mission</Link>
          <Link to={homeAnchor('team')}>Our Team</Link>
          <Link to={homeAnchor('invest')}>Investment</Link>
        </div>

        <div className="footer__col">
          <h4>Help Center</h4>
          <Link to="/faq/customer/">Customer FAQ</Link>
          <Link to="/faq/rider/">Rider FAQ</Link>
          <Link to="/faq/merchant/">Merchant FAQ</Link>
          <Link to="/faq/vendor/">Vendor FAQ</Link>
          <Link to="/support/">Contact Support</Link>
          <Link to="/support/">Delete / Restore Account</Link>
        </div>

        <div className="footer__col">
          <h4>Policies</h4>
          <Link to="/policies/user/">Customer Policy</Link>
          <Link to="/policies/rider/">Rider &amp; Driver Policy</Link>
          <Link to="/policies/merchant/">Merchant Policy</Link>
          <Link to="/policies/vendor/">Vendor Policy</Link>
        </div>

        <div className="footer__col">
          <h4>Get in Touch</h4>
          <a href="tel:+233508571134">+233 50 857 1134</a>
          <a href="mailto:info@bikesdrop.com">info@bikesdrop.com</a>
          <a href="mailto:support@bikesdrop.com">support@bikesdrop.com</a>
          <span className="footer__mute">Accra, Ghana</span>
        </div>
      </div>

      <div className="container footer__bottom">
        <span>© {year} BikesDrop Business and Logistics LTD. All rights reserved.</span>
        <span>Proudly built in Ghana</span>
      </div>
    </footer>
  );
}
